import { Modal } from "antd";

export const ConfirmationModal = ({
  open,
  onCancel,
  onOk,
  okText = "Remover",
}) => {
  return (
    <Modal
      title="Caso necessário, você poderá editar a resposta posteriormente. Deseja prosseguir?"
      open={open}
      onCancel={onCancel}
      cancelText="Cancelar"
      onOk={onOk}
      okText={okText}
      destroyOnClose={true}
      closable={false}
      okButtonProps={{
        style: {
          backgroundColor: "var(--color-purple)",
          color: "#fff",
        },
      }}
    ></Modal>
  );
};
